<!-- Tabs navigation removed; subroutes now handled by sidebar navigation -->
<!-- <shopbox-tab-group [tabs]='tabs' [grants]='noGrants'> -->
<sb-page-header></sb-page-header>
<div class="min-w-0 overflow-x-auto">
  <router-outlet (activate)='onActivate($event)'></router-outlet>
</div>
<!-- </shopbox-tab-group> -->
